import {authorize, IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import {
    FalconPaymentRequest,
    InstalmentsInfo,
    NewCardForm,
    ProductsEnum,
} from "@ferry/journey-services";
import {FalconNavigatorHeader, Footer} from "@ferry/portal-core";
import * as React from 'react';
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {CardForm} from "../../../../../components/payments/CardForm";
import {getAmountWithDecimalDigits} from "../../../../../CommonFunctions";
import {lazyInject} from "@athena-portal/core";
import {FailedPaymentMessage} from "../../../../../components/payments/FailedPaymentMessage";
import {Types} from "../../../../../Types";
import type {ICustomerPortalService} from "../../../../../services/ICustomerPortalService";

interface IParams {
    policyNumber: string;
    [key: string]: string | undefined
}

interface IState {
    newCardForm?: NewCardForm
}

@authorize
export class PayOffBalanceNewCardPagePlain extends React.Component<IWithRouterProps<IParams>, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IWithRouterProps<IParams>) {
        super(props);

        this.state = {}
    }

    public componentDidMount(): void {
        const request: FalconPaymentRequest = new FalconPaymentRequest();
        const policyNumber = this.props.params.policyNumber;
        request.invoiceType = "PAYOFF";
        request.product = ProductsEnum.WOLF_MOTOR;

        this.customerPortalService.getInstalmentsInfo(this.props.params.policyNumber, false).subscribe((output: InstalmentsInfo) => {
            const payOffAmount = output.payOffAmount;
            request.amount = payOffAmount;
            window.sessionStorage.setItem("paymentAmount", getAmountWithDecimalDigits(payOffAmount).toString());

            this.customerPortalService.authorizeNewCard(request, policyNumber).subscribe((newCardForm: NewCardForm) => {
                this.setState({
                    newCardForm
                })
            })
        })
    }

    public render(): React.ReactNode {
        if (this.state.newCardForm) {
            const customLockedTitle = {
                html:
                    (
                        <div className="text-group title plugin no-indent-desktop">
                            <h1 className="m-0">
                                <span className='secure-payment-icon'>Add new card</span>
                            </h1>
                        </div>
                    )
            };
            return (
                <>
                    <FalconHeader/>
                    {this.props.location.state?.paymentFailed &&
                        <FailedPaymentMessage/>}
                    <div className="plugin">
                        <FalconNavigatorHeader
                            back={`/dashboard/monthlyPaymentHistory/${this.props.params.policyNumber}`}
                            title={customLockedTitle}/>
                        <CardForm newCardForm={this.state.newCardForm}
                                  verifyNewCardFailed={false}
                                  policyNumber={this.props.params.policyNumber}
                        />
                    </div>
                    <Footer/>
                </>
            )
        } else {
            return <Overlay show={true}/>
        }
    }
}

export const PayOffBalanceNewCardPage = withRouter<{}, IParams>(PayOffBalanceNewCardPagePlain)
